export const common = {
  // Navigation
  nav_home: 'Hjem',
  nav_categories: 'Kategorier',
  nav_guides: 'Guides',
  nav_reviews: 'Anmeldelser',
  nav_shipping: 'Forsendelse',
  nav_about: 'Om os',
  nav_contact: 'Kontakt',
  
  // Language
  language: 'Sprog',
  lang_en: 'English',
  lang_de: 'Deutsch',
  lang_fr: 'Français',
  lang_da: 'Dansk',
  
  // Hero
  hero_title: 'AllChinaBuy Spreadsheet — Find Produkter, Links & Pålidelige Fund',
  hero_subtitle: 'Udforsk de nyeste AllChinaBuy Spreadsheet-ressourcer, produktfund, købsguides, QC-informationer, forsendelsesguides og nyttige produktlinks — alt organiseret på ét sted.',
  hero_cta_primary: 'Udforsk AllChinaBuy Spreadsheet',
  hero_cta_secondary: 'Besøg Hovedwebsitet',
  
  // Search
  search_placeholder: 'Søg efter produkter, kategorier eller AllChinaBuy Spreadsheet-ressourcer...',
  
  // Categories
  categories_title: 'Populære Kategorier',
  categories_subtitle: 'Gennemse vores kuraterede produktkategorier og find præcis det, du har brug for',
  category_shoes: 'Sko',
  category_hoodies: 'Hoodies / Sweatre',
  category_tshirts: 'T-Shirts',
  category_jackets: 'Jakker',
  category_pants: 'Bukser / Shorts',
  category_headwear: 'Hovedbeklædning',
  category_sets: 'Sæt',
  category_underwear: 'Undertøj / Underbukser',
  category_jersey: 'Trøjer',
  category_accessories: 'Tilbehør',
  category_bags: 'Tasker',
  category_belts: 'Bælter',
  category_perfumes: 'Parfumer',
  category_other: 'Andet',
  
  // CTA Buttons on homepage
  cta_allchinabuy_spreadsheet: 'AllChinaBuy Spreadsheet',
  cta_buy_it_now: 'Køb Nu',
  
  // About section
  about_title: 'Hvad er AllChinaBuy Spreadsheet?',
  about_p1: 'AllChinaBuy Spreadsheet er dit ultimative ressource-hub til at opdage kvalitetsprodukter, pålidelige sælgerlinks og detaljerede købsguides til AllChinaBuy-platformen. Vi kuraterer de bedste fund inden for sko, tøj, tilbehør og mere — og sparer dig timer med research.',
  about_p2: 'Vores mission er enkel: Forbinde europæiske købere med de bedste AllChinaBuy-produkter, samtidig med at vi giver ærlige anmeldelser, forsendelsesguides og sikkerhedstips. Hvert link og hver anbefaling er omhyggeligt verificeret for at sikre, at du får reel værdi.',
  about_cta: 'Lær mere om os',
  
  // Article Preview
  article_title: 'AllChinaBuy Spreadsheet Guide',
  article_excerpt: 'Opdag, hvordan du effektivt bruger AllChinaBuy Spreadsheet til at finde de bedste produkter, verificere sælgere og spare på forsendelsesomkostninger. Denne komplette guide dækker alt fra grundlæggende for begyndere til avancerede produktresearch-teknikker.',
  article_read_more: 'Læs Fuld Guide',
  article_meta: '8 min læsetid • Opdateret august 2026',
  
  // Trust badges
  trust_title: 'Hvorfor Købere Stoler på Os',
  trust_1_title: 'Kuraterede Fund',
  trust_1_desc: 'Hvert produkt er håndplukket og verificeret af vores team',
  trust_2_title: 'Forsendelsesguides',
  trust_2_desc: 'Detaljerede forsendelsesomkostningsopdelinger og leveringstider',
  trust_3_title: 'Sikker Indkøb',
  trust_3_desc: 'Sikkerhedstips og svindelpræventionsstrategier inkluderet',
  trust_4_title: 'Regelmæssige Opdateringer',
  trust_4_desc: 'Spreadsheets og links opdateres ugentligt for nøjagtighed',
  
  // Footer
  footer_tagline: 'Dit pålidelige AllChinaBuy Spreadsheet ressource-hub',
  footer_links: 'Hurtige Links',
  footer_legal: 'Juridisk',
  footer_privacy: 'Privatlivspolitik',
  footer_terms: 'Servicevilkår',
  footer_disclaimer: 'Ansvarsfraskrivelse',
  footer_editorial: 'Redaktionel Politik',
  footer_copyright: '© 2026 allchinabuyspread.de. Alle rettigheder forbeholdes.',
  footer_nofollow_notice: 'Alle eksterne links til tredjepartswebsites er nofollow.',
  
  // Breadcrumb
  breadcrumb_home: 'Hjem',
  
  // Misc
  scroll_to_top: 'Rul til toppen',
  loading: 'Indlæser...',
  
  // SEO Article specific
  article_h1: 'AllChinaBuy Spreadsheet Guide — Komplet Ressource 2026',
  article_intro: 'Velkommen til den mest omfattende AllChinaBuy Spreadsheet guide, der er tilgængelig online. Uanset om du er ny på platformen eller en erfaren køber, der ønsker at optimere din produktresearch, dækker denne guide alt, hvad du behøver at vide om at udnytte AllChinaBuy spreadsheets til smartere shopping.',
  article_what_is_title: 'Hvad er AllChinaBuy Spreadsheet?',
  article_what_is_p1: 'AllChinaBuy Spreadsheet er en kurateret samling af produktlinks, sælgerinformationer, prisdata og kvalitetskontrol-noter (QC) organiseret i et let navigérbart format. Tænk på det som et produktkatalog, der forbinder dig direkte med verificerede sælgere på tværs af populære kategorier som sko, hoodies, t-shirts, jakker og tilbehør.',
  article_what_is_p2: 'I modsætning til tilfældige produktlister, som du måske finder på fora eller sociale medier, giver et velvedligeholdt AllChinaBuy Spreadsheet strukturerede data inklusive kategorifiltre, prisintervaller, sælgerbedømmelser og direkte købslinks. Denne organisation sparer dig betydelig tid og reducerer risikoen for at købe fra upålidelige kilder.',
  article_how_to_title: 'Sådan Bruger Du AllChinaBuy Spreadsheet Effektivt',
  article_how_to_step1: 'Start med at identificere den produktkategori, du er interesseret i. Spreadsheets er typisk organiseret efter kategorier som Sko, Tøj, Tilbehør, Tasker og Elektronik. Brug kategorifilteret til at indsnævre din søgning.',
  article_how_to_step2: 'Gennemgå sælgerinformationen og QC-noterne, før du klikker på et produktlink. Kig efter sælgere med konsistent positiv feedback og ny transaktionshistorik. Spreadsheets bør inkludere sælgerverifikationsindikatorer, hvor det er muligt.',
  article_how_to_step3: 'Sammenlign priser på tværs af lignende produkter. AllChinaBuy Spreadsheet indeholder ofte flere muligheder for den samme produkttype, så du kan finde den bedste balance mellem kvalitet og pris.',
  article_how_to_step4: 'Brug forsendelsesomkostningsestimaterne i spreadsheets til at beregne dine samlede leverede omkostninger. Tag højde for eventuelle toldafgifter afhængigt af dit destinationsland.',
  article_categories_title: 'Populære Produktkategorier i Spreadsheet',
  article_safety_title: 'Sikkerhedstips Ved Brug af AllChinaBuy Spreadsheets',
  article_safety_p1: 'Selvom AllChinaBuy Spreadsheets er utroligt nyttige værktøjer, er det vigtigt at praktisere sikre indkøbsvaner. Verificer altid, at det spreadsheet, du bruger, kommer fra en pålidelig kilde. Undgå spreadsheets, der deles på uverificerede fora eller af ukendte brugere.',
  article_safety_p2: 'Før du foretager et køb, skal du dobbelttjekke produktlinket og sikre, at det dirigerer til den officielle AllChinaBuy-platform. Vær forsigtig med forkortede URL\'er eller links, der omdirigerer via flere domæner. Hvis et tilbud lyder for godt til at være sandt, er det det sandsynligvis også.',
  article_shipping_title: 'Forstå AllChinaBuy Forsendelsesomkostninger',
  article_shipping_p1: 'Forsendelsesomkostninger fra AllChinaBuy varierer afhængigt af din placering, vægten af dine varer og den forsendelsesmetode, du vælger. Almindelige muligheder inkluderer standard posttjenester, ekspreskuriere som DHL og EMS, og konsoliderede forsendelsestjenester.',
  article_shipping_p2: 'Europæiske købere bør være opmærksomme på, at pakker kan være underlagt moms og toldafgifter ved ankomsten. Disse yderligere omkostninger er ikke inkluderet i produktprisen eller forsendelsesgebyret vist på AllChinaBuy-platformen. Budgettér altid for potentielle importafgifter for at undgå overraskelser.',
  article_faq_title: 'Ofte Stillede Spørgsmål',
  faq_q1: 'Er AllChinaBuy Spreadsheet gratis at bruge?',
  faq_a1: 'De fleste AllChinaBuy Spreadsheets, der deles af fællesskabet, er gratis at tilgå. Nogle premium eller omfattende kuraterede spreadsheets kan dog kræve et lille gebyr eller abonnement. Vi anbefaler at starte med gratis fællesskabsressourcer, før du overvejer betalte muligheder.',
  faq_q2: 'Hvor ofte opdateres spreadsheets?',
  faq_a2: 'Opdateringsfrekvensen varierer afhængigt af skaberen. Kvalitetsspreadsheets opdateres typisk ugentligt eller hver anden uge for at afspejle aktuelle lagerniveauer, prisændringer og nye produktankomster. Tjek altid den sidste opdateringsdato, før du bruger et spreadsheet.',
  faq_q3: 'Kan jeg stole på sælgerne i spreadsheets?',
  faq_a3: 'Pålidelige spreadsheet-skabere verificerer sælgere, før de inkluderer dem. Vi anbefaler dog altid at foretage din egen verificering. Tjek seneste anmeldelser, transaktionshistorik og QC-billeder, før du forpligter dig til et køb.',
  faq_q4: 'Hvad skal jeg gøre, hvis et produktlink er ødelagt?',
  faq_a4: 'Ødelagte links kan ske, når produkter er udsolgt, eller sælgere opdaterer deres lister. Rapporter ødelagte links til spreadsheet-skaberen, hvis det er muligt. Alternativt kan du bruge produktbeskrivelsen og billedet til at søge efter varen direkte på AllChinaBuy.',
  faq_q5: 'Er priserne i spreadsheets nøjagtige?',
  faq_a5: 'Priser er nøjagtige på tidspunktet for spreadsheet-opdateringen. Sælgere kan dog ændre priser uden varsel. Verificer altid den aktuelle pris på AllChinaBuy-platformen, før du fuldfører dit køb.',
  article_conclusion_title: 'Konklusion',
  article_conclusion: 'AllChinaBuy Spreadsheet er et uundværligt værktøj for enhver, der ønsker at shoppe smartere på AllChinaBuy-platformen. Ved at forstå, hvordan man navigerer i kategorier, verificerer sælgere og estimerer samlede omkostninger, kan du markant forbedre din shoppingoplevelse og finde bedre produkter til fair priser. Bogmærk denne guide og vend tilbage, når du har brug for en genopfriskning af AllChinaBuy Spreadsheet bedste praksis.',
  article_cta: 'Udforsk Flere AllChinaBuy Ressourcer',
  
  // Disclaimer
  disclaimer: 'Ansvarsfraskrivelse: Dette website er et uafhængigt ressource-hub og er ikke tilknyttet AllChinaBuy. Produktpriser, tilgængelighed og politikker kan ændres. Verificer altid information direkte på den officielle platform, før du foretager køb.',
  
  // Not Found
  notfound_title: 'Side Ikke Fundet',
  notfound_desc: 'Den side, du leder efter, findes ikke.',
  notfound_back: 'Tilbage til Hjem',
};

export default common;